export const DATA_AUTOMATION_VALUE = "price-cell";
